import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import { Link } from 'react-router'

import LeftSide from './LeftSide'
import LeftSideCommunication from './LeftSideCommunication'
import RightSide  from './RightSide'
import Divider from 'material-ui/Divider'

import Communication from 'components/Communication'
import Scroll from 'components/Scroll'

export default class PropertyForm extends Component{
	render(){
		let { props } = this
		let colspan= props.leftOnly?1:2
		let propertyID = props.id
		let leftSide= () =>{
			if (props.oneProperty){
				return <LeftSideCommunication propertyID={propertyID} colspan={colspan}/>
			} else {
				return <LeftSide propertyID={propertyID} colspan={colspan}/>
			}
		}
		return(
			<div style={{position:"relative"}} >

				<Scroll name="dashboardPropertyForm" key={propertyID}
					style={{position:"relative", height:"calc(100vh - 64px)", overflowX: "hidden", background: "#ededed"}}
				>
					<main style={{minHeight:"calc(100vh - 64px)", display:(colspan>1)?"flex":"block", overflowY: "hidden"}}>
						{leftSide()}
						{!props.leftOnly && <RightSide propertyID={propertyID} colspan={colspan} propertyAlias={"All properties"}/>}
					</main>
				</Scroll>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/routes/landlord/dashboard/propertyForm/index.js